export default __webpack_public_path__ + "static/media/dec-22.5fc81637.jpg";